import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Contactpage from '../../components/Contactpage/Contactpage'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import Logo from '../../images/logo-2.svg'
import Hero3 from './hero3';
const ContactPage =() => {
    return(
        <Fragment>
            <Navbar hclass={'wpo-site-header'} Logo={Logo} />
            <Hero3 />
            <Contactpage/>
            <Footer hclass={'footer-section section-padding'} />
            <Scrollbar />
        </Fragment>
    )
};
export default ContactPage;

